import axios from "axios";
import Vue from "vue";
import { ir } from "../check_domain_ir";
export default class InsuranceContent {
  constructor(qr_id) {
    this.id = qr_id;
    this.api = null;
    this.#initAxios();
  }

  #initAxios() {
    let id_token = localStorage.getItem("id_token");

    this.api = axios.create({
      baseURL: ir(process.env.VUE_APP_URL),
      timeout: 15000,
      headers: {
        Authorization: !!id_token ? "Bearer " + id_token : undefined,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
  }

  list() {
    return new Promise((resolve, reject) => {
      this.api
        .get("/insurances")
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  storeQrInsurance(fields = { qr_id: this.id, category_id: [] }) {
    return new Promise((resolve, reject) => {
      this.api
        .post("/insurances", fields)
        .then((data) => {
          this.qrInsurances(fields.qr_id)
            .then((qrData) => resolve(qrData))
            .catch((err) => resolve(data));
        })
        .catch((err) => reject(err));
    });
  }

  qrInsurances(qr_id = this.id) {
    return new Promise((resolve, reject) => {
      this.api
        .get(`/insurances/${qr_id}`)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  qrDeleteInsurance(params = { qr_id: this.id, category_id: null }) {
    return new Promise((resolve, reject) => {
      this.api
        .delete(`/insurances/${params.category_id}`, {
          params,
        })
        .then((data) => {
          this.qrInsurances(params.qr_id)
            .then((qrData) => resolve(qrData))
            .catch((err) => resolve(data));
        })
        .catch((err) => reject(err));
    });
  }
}
